import { graphql } from '@/gql'

export const FILE_ID_TO_URL = graphql(`
  query fileIdToUrl($id: UUID!) {
    storageIdToDirectUrl(input: { id: $id }) {
      url
    }
  }
`)
